import Spotpicker from './spotpicker'

export default Spotpicker
